import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { utilActivityTypeFormDefault } from "@factory/form/form.default";
import { UtilActivityTypeFormRule, UtilActivityTypeFormSchema } from "@factory/form/form.rule";
import { useQyCreateUtilActivityType } from "@factory/query/util-activity-type.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewUtilActivityType() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateUtilActivityType } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New UtilActivityType is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addUtilActivityType, isLoading: isCreating } =
    useQyCreateUtilActivityType(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<UtilActivityTypeFormSchema>({
    defaultValues: utilActivityTypeFormDefault,
    resolver: zodResolver(UtilActivityTypeFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: UtilActivityTypeFormSchema) => {
    const formData = mapCreateUtilActivityType(form);
    addUtilActivityType(formData);
  };
  const handleValidateError = (err: FieldErrors<UtilActivityTypeFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
